
export class CASNumberShort {
  public casNumber: string;
  public commonName: string;
  public isCommonName: boolean;
  public ingredientName: string;
}
